import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-csr-approved',
  templateUrl: './csr-approved.component.html',
  styleUrls: ['./csr-approved.component.css'],
})
export class CsrApprovedComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  private csrApproval = environment.url + environment.csrApproval;
  /**
   * Construct a new CsrApprovedComponent.
   * @param data The data that has been passed from the parent component.
   * @param fb The form builder service.
   * @param makeapi The API service.
   * @param notify The notification service.
   * @param dialogRef The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<CsrApprovedComponent>
  ) {
    /**
     * The form group for the reason form.
     */
    this.reasonForm = this.fb.group({
      /**
       * The id of the CSR.
       */
      id: [''],
      /**
       * The status of the CSR.
       */
      status: [''],
      /**
       * The reason for approving the CSR.
       * Required.
       */
      reason: ['', [Validators.required]],
    });
    /**
     * The data that has been passed from the parent component.
     */
    this.datas = data;
    /**
     * Patch the form values with the CSR ID and status.
     */
    let getform = this.reasonForm.value;
    getform.id = this.datas._id;
    getform.status = 2;
    this.reasonForm.patchValue(getform);
  }

  ngOnInit(): void {}
  get add() {
    return this.reasonForm.controls;
  }
  sam;
  /**
   * Saves the approval reason to the API.
   * Constructs the request payload and sends it using the API service.
   * Closes the dialog and notifies success upon completion.
   */
  saveReason() {
    // Construct the request payload
    const req = {
      id: this.datas._id, // CSR ID
      status: 1, // Status indicating approval
      remark: this.reasonForm.value.reason, // Approval reason
    };

    // Send the request to the API
    return this.makeapi
      .method(this.csrApproval, req, 'post')
      .subscribe((data) => {
        // Notify the user about the success
        this.notify.notifysuccess(data.responseMessage);

        // Close the dialog
        this.dialogRef.close();
      });
  }
  /**
   * Closes the dialog without performing any action.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    // Reset the form fields
    this.reasonForm.reset();

    // Close the dialog
    this.dialogRef.close();
  }
}
